import StyledContainer from "style/styledContainer"

import { ReactComponent as HotSvg } from 'assets/svgs/hot.svg'
import { ReactComponent as ArrowRight3Svg } from 'assets/svgs/arrow_right_3.svg'
import styled from "styled-components"
import { Row } from "style/preset"
import { useAppDispatch } from "hooks/redux/hooks"
import { setOpenBestDealWin } from "hooks/redux/slices/appSlice"
import { Tooltip } from "react-tooltip"
import { ToolTipCom } from "./TransferInfoCom"

const BestDealCom = ({seeWhy = false}: {seeWhy?: boolean}) => {
    const dispatch = useAppDispatch()

    return <>
        <BestDealWrap onClick={() => seeWhy && dispatch(setOpenBestDealWin(true))} data-tooltip-id="tootltip_best_deal">
            <HotSvgWrap></HotSvgWrap>
            <BestTextWrap $roobertSemiBold>Best deal guaranteed</BestTextWrap>
            {
                seeWhy && <ShowWhyBoxWrap>
                    <ShowWhyTextWrap>See why</ShowWhyTextWrap>
                    <ArrowRight3SvgWrap></ArrowRight3SvgWrap>
                </ShowWhyBoxWrap>
            }
        </BestDealWrap>
        <Tooltip id="tootltip_best_deal" place="bottom" style={{ backgroundColor:  'transparent', width: '258px', padding: '0'}}>
            <ToolTipCom>
                Chainge stands out as the best deal on the market by providing the most competitive prices primarily attributed to its remarkably low fees and ability to access cross-chain liquidity. While other aggregators and DEXs may appear to offer slightly higher outputs for small tx's, the separate fees charged for gas are consistently higher compared to Chainge's rates and not included in the output amount. 
                <StyledContainer $height="10px"></StyledContainer>
                This distinction ensures that you experience a much more favorable and transparent pricing structure when engaging with our dApp.
            </ToolTipCom>
        </Tooltip>
    </>
}


// best deal guaranteed
const ShowWhyBoxWrap = styled(Row)`
    display: none;
`

const BestDealWrap = styled(Row)`
    padding: 6px 8px;
    border-radius: 9px;
    background-color: #F6F5F4;
    position: relative;
    left: -6px;
    cursor: pointer;
    &:hover {
        background-color: #fff;
        box-shadow: 0px 10px 32px -4px rgba(24, 39, 75, 0.10), 0px 6px 14px -6px rgba(24, 39, 75, 0.12);
        ${ShowWhyBoxWrap} {
            display: flex;
        }
    }
`

const HotSvgWrap = styled(HotSvg)`
    width: 20px;
    height: 20px;
`

const BestTextWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    color: #DF2935;
    margin-left: 6px;
`

const ShowWhyTextWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    color: #DF2935;
    margin: 0 4px 0 14px;
`

const ArrowRight3SvgWrap = styled(ArrowRight3Svg)`
    width: 12px;
    height: 12px;
`

export default BestDealCom